var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"anchor-bar__link link-reset",attrs:{"href":("#" + (_vm.anchor.elId))},on:{"click":function($event){$event.preventDefault();return _vm.onLink.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.anchor.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }